import { render, staticRenderFns } from "./FeCheckbox.vue?vue&type=template&id=635e0b4a&scoped=true&"
import script from "./FeCheckbox.vue?vue&type=script&lang=js&"
export * from "./FeCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./FeCheckbox.vue?vue&type=style&index=0&id=635e0b4a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635e0b4a",
  null
  
)

export default component.exports